<div class="header">
  <p class="headline">
    {{ 'textOnly.consultantProfile' | translate }} {{ berater.vorname }} {{ berater.nachname }}
  </p>
  <p>{{ berater.personaldaten.intro }}</p>
</div>
<hr/>
<p class="headline">{{ 'textOnly.personalData' | translate }}</p>
<div class="personal-daten">
  <div>
    <p class="question">{{ 'textOnly.vintage' | translate }}</p>
    <p class="answer">{{ berater.personaldaten.jahrgang }}</p>
  </div>
  <div>
    <p class="question">{{ 'textOnly.nationality' | translate }}</p>
    <p class="answer">{{ berater.personaldaten.nationalitaet }}</p>
  </div>
  <div>
    <p class="question">{{ 'textOnly.placeOfResidence' | translate }}</p>
    <p class="answer">{{ berater.personaldaten.wohnort }}</p>
  </div>
  <div>
    <p class="question">{{ 'textOnly.position' | translate }}</p>
    <p class="answer">{{ berater.personaldaten.position }}</p>
  </div>
  <div>
    <p class="question">{{ 'textOnly.consultantSince' | translate }}</p>
    <p class="answer">{{ berater.personaldaten.beraterSeit }}</p>
  </div>
  <div>
    <p class="question">{{ 'textOnly.availableFrom' | translate }}</p>
    <p class="answer">{{ berater.personaldaten.verfuegbar }}</p>
  </div>
  <div>
    <p class="question">{{ 'textOnly.willingnessToTravel' | translate }}</p>
    <p class="answer">{{ berater.personaldaten.reisebereitschaft | travelWillingness }}</p>
  </div>
  <div>
    @if (berater.personaldaten.reisebereitschaft === "Eingeschränkt") {
      <p class="question">{{ 'textOnly.limitation' | translate }}</p>
      <p class="answer">{{ berater.personaldaten.einschraenkung }}</p>
    }
  </div>
  <div>
    <p class="question">{{ 'textOnly.languages' | translate }}</p>
    @for (sprachen of languageEntries; track $index) {
      <p class="answer">
        @if (sprachen.level) {
          {{ languageName(sprachen.language) }} ({{ 'personalData.languageLevels.' + sprachen.level | translate }})
        } @else {
          {{ languageName(sprachen.language) }}
        }
      </p>
    }
  </div>
  <div>
    <p class="question">{{ 'textOnly.industries' | translate }}</p>
    @for (branchen of berater.personaldaten.branchen; track $index) {
      <p class="answer">{{ branchen | vocabulary:'industry' }}</p>
    }
  </div>
  <div>
    <p class="question">{{ 'textOnly.mainFocus' | translate }}</p>
    @for (schwerpunkte of berater.personaldaten.schwerpunkte;
      track schwerpunkte) {
      <p class="answer">{{ schwerpunkte | vocabulary:'mainFocus' }}</p>
    }
  </div>
</div>
<hr/>
<div class="ausbildung">
  <p class="headline">{{ 'textOnly.education' | translate }}</p>
  <table>
    <tr>
      <th>{{ 'textOnly.beginning' | translate }}</th>
      <th>{{ 'textOnly.end' | translate }}</th>
      <th>{{ 'textOnly.institution' | translate }}</th>
      <th>{{ 'textOnly.trainingCourse' | translate }}</th>
      <th>{{ 'textOnly.location' | translate }}</th>
      <th>{{ 'textOnly.diploma' | translate }}</th>
    </tr>
    @for (ausbildung of berater.ausbildung; track ausbildung) {
      <tr>
        <td>{{ ausbildung.beginn | date: "MM.yyyy" }}</td>
        <td>{{ ausbildung.ende | date: "MM.yyyy" }}</td>
        <td>{{ ausbildung.ausbildungseinrichtung }}</td>
        <td>{{ ausbildung.ausbildungsgang }}</td>
        <td>{{ ausbildung.ort }}</td>
        @if (!ausbildung.abschlussErreicht) {
          <td>{{ 'textOnly.no' | translate }}</td>
        } @else {
          <td>{{ ausbildung.abschluss }}</td>
        }
      </tr>
    }
  </table>
</div>
<hr/>
<div class="werdegang">
  <p class="headline">{{ 'textOnly.career' | translate }}</p>
  <table>
    <tr>
      <th>{{ 'textOnly.beginning' | translate }}</th>
      <th>{{ 'textOnly.end' | translate }}</th>
      <th>{{ 'textOnly.enterprise' | translate }}</th>
      <th>{{ 'textOnly.jobTitle' | translate }}</th>
      <th>{{ 'textOnly.location' | translate }}</th>
      <th>{{ 'textOnly.task' | translate }}</th>
    </tr>
    @for (werdegang of berater.werdegang; track werdegang) {
      <tr>
        <td>{{ werdegang.beginn | date: "MM.yyyy" }}</td>
        <td>{{ werdegang.ende | date: "MM.yyyy" }}</td>
        <td>{{ werdegang.unternehmen }}</td>
        <td>{{ werdegang.stellenbezeichnung }}</td>
        <td>{{ werdegang.ort }}</td>
        <td>{{ werdegang.taetigkeit }}</td>
      </tr>
    }
  </table>
</div>
<hr/>
<div class="schulung">
  <p class="headline">{{ 'textOnly.training' | translate }}</p>
  <table>
    <tr>
      <th>{{ 'textOnly.beginning' | translate }}</th>
      <th>{{ 'textOnly.provider' | translate }}</th>
      <th>{{ 'textOnly.course' | translate }}</th>
    </tr>
    @for (schulung of berater.schulungen; track schulung) {
      <tr>
        <td>{{ schulung.beginn | date: "MM.yyyy" }}</td>
        <td>{{ schulung.schulungsanbieter }}</td>
        <td>{{ schulung.lehrgang }}</td>
      </tr>
    }
  </table>
</div>
<hr/>
<div class="zertifikate">
  <p class="headline">{{ 'textOnly.certificates' | translate }}</p>
  <table>
    <tr>
      <th>{{ 'textOnly.beginning' | translate }}</th>
      <th>{{ 'textOnly.certificate' | translate }}</th>
      <th>{{ 'textOnly.issuer' | translate }}</th>
      <th>{{ 'textOnly.trainingProvider' | translate }}</th>
      <th>{{ 'textOnly.certificateNumber' | translate }}</th>
    </tr>
    @for (zertifikate of berater.zertifikate; track zertifikate) {
      <tr>
        <td>{{ zertifikate.beginn | date: "MM.yyyy" }}</td>
        <td>{{ zertifikate.lehrgang }}</td>
        <td>{{ zertifikate.schulungsanbieter }}</td>
        <td>{{ zertifikate.trainingsanbieter }}</td>
        <td>{{ zertifikate.zertifikatnummer }}</td>
      </tr>
    }
  </table>
</div>
<hr/>
<div class="projekte">
  <p class="headline">{{ 'textOnly.projects' | translate }}</p>
  @for (projekt of berater.projekte; track projekt) {
    <table class="projekt-tabelle">
      <tr>
        <th>{{ 'textOnly.beginning' | translate }}</th>
        <th>{{ 'textOnly.end' | translate }}</th>
        <th>{{ 'textOnly.customer' | translate }}</th>
        <th>{{ 'textOnly.project' | translate }}</th>
        <th>{{ 'textOnly.role' | translate }}</th>
        <th>{{ 'textOnly.deploymentLocation' | translate }}</th>
        <th>{{ 'textOnly.teamSize' | translate }}</th>
        <th>{{ 'textOnly.projectTotalSize' | translate }}</th>
        <th>{{ 'textOnly.methodology' | translate }}</th>
      </tr>
      <tr>
        <td>{{ projekt.beginn | date: "MM.yyyy" }}</td>
        <td>{{ projekt.ende | date: "MM.yyyy" }}</td>
        <td>{{ projekt.kunde }}</td>
        <td>{{ projekt.projektname }}</td>
        <td>{{ projekt.stelle }}</td>
        <td>{{ projekt.location }}</td>
        <td>{{ projekt.teamSize }}</td>
        <td>{{ projekt.projectSize }}</td>
        <td>@for (methodik of projekt.methodik; track $index; let last = $last) {{{ methodik | vocabulary:'method' }}@if (!last) {,}}</td>
      </tr>
      <tr>
        <th colspan="9">{{ 'textOnly.description' | translate }}</th>
      </tr>
      <tr>
        <td colspan="9">{{ projekt.beschreibung }}</td>
      </tr>
      <tr>
        <th colspan="3">{{ 'textOnly.duty' | translate }}</th>
        <th colspan="3">{{ 'textOnly.details' | translate }}</th>
        <th colspan="2">{{ 'textOnly.skills' | translate }}</th>
      </tr>
      @for (aufgabe of projekt.tasks; track aufgabe) {
        <tr>
          <td colspan="3">{{ aufgabe.caption }}</td>
          <td colspan="3">{{ aufgabe.details }}</td>
          <td colspan="2">
            @for (skill of aufgabe.skills; track skill) {
              <div>{{ skill | vocabulary:'skillCategory' }} → {{ skill | vocabulary:'skill' }}</div>
            }
          </td>
        </tr>
      }
    </table>
  }
</div>
<hr/>
<div class="faehigkeiten">
  <p class="headline">{{ 'textOnly.skills' | translate }}</p>
  <table>
    <tr>
      <th>{{ 'textOnly.category' | translate }}</th>
      <th>{{ 'textOnly.skill' | translate }}</th>
      <th>{{ 'textOnly.level' | translate }}</th>
    </tr>
    @for (faehigkeit of berater.faehigkeiten; track faehigkeit) {
      <tr>
        <td>{{ faehigkeit | vocabulary:'skillCategory' }}</td>
        <td>{{ faehigkeit | vocabulary:'skill' }}</td>
        <td>{{ faehigkeit.level }}</td>
      </tr>
    }
  </table>
</div>
